export default "__VITE_ASSET__DC0$R2Fa__"